module.exports = "<div class=\"general-condition-container\">\n  <div class=\"general-condition-title\">\n    <p *ngIf=\"isActivationRequest\" class=\"pre-title\">\n      Catalogo Soci - Raccolta punti\n    </p>\n    <p class=\"main-title\">\n      <ng-content></ng-content>\n    </p>\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/molecules/alg-autoricarica-general-condition/alg-autoricarica-general-condition.component.html
// module id = ./src/app/components/molecules/alg-autoricarica-general-condition/alg-autoricarica-general-condition.component.html
// module chunks = main